<template>
  <div
    class="posifix rightDialog boxShadow"
    :class="{
      show: visible,
    }"
    v-qx-full-h="64"
  >
    <div class="title clearPa">
      <span class="left word">操作日志</span>
      <span class="right iconfont cur" @click="visible = false">&#xe614;</span>
    </div>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
<!--      <section class="paginationBox clearPa">-->
<!--        &lt;!&ndash; 分页组件 &ndash;&gt;-->
<!--        <section class="right">-->
<!--          <el-pagination-->
<!--            @size-change="handleSizeChange"-->
<!--            @current-change="handleCurrentChange"-->
<!--            :current-page="tableData.currentPage"-->
<!--            :page-sizes="[10, 20, 50]"-->
<!--            :page-size="tableData.pageSize"-->
<!--            layout="total, sizes, prev, pager, next, jumper"-->
<!--            :total="tableData.total"-->
<!--          ></el-pagination>-->
<!--        </section>-->
<!--        &lt;!&ndash; 分页组件 end &ndash;&gt;-->
<!--      </section>-->
      <!-- 分页 end -->
    </section>
  </div>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  logList,
} from 'api';
import { normalizePaginationResponse } from 'api/paginationCompat';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    busiCode: {
      type: String,
    },
    auditCode: {
      type: String,
    },
  },
  data () {
    return {
      searchBoxData: {
        busiId: '',
        busiCode: this.busiCode,
        auditCode: this.auditCode,
      },
      visible: false,
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '操作时间',
          },
          // {
          //   prop: 'updateDate',
          //   label: '操作时间',
          // },
          {
            prop: 'opName',
            label: '操作人',
          },
          {
            prop: 'operComment',
            label: '操作信息',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    async getList (params) {
      const response = await logList(params);
      return normalizePaginationResponse(response);
    },
    show (busiId) {
      this.visible = true;
      this.searchBoxData.busiId = busiId;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.rightDialog{
  bottom: 0;
  right: -1000px;
  width: 40%;
  min-width: 600px;
  background: #fff;
  border-radius: 8px;
  z-index: 999;
  transition: all .3s;
  overflow-y: auto;
  .title{
    height: 48px;
    line-height: 48px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #fafafa;
    .word{
      color: #333;
      font-size: 18px;
    }
  }
  .tablePage{
    padding: 0 16px;
  }
}
.tableBox{
  height: 500px;
  overflow-y: auto;
}
.rightDialog.show{
  right: 0;
}
</style>
